import { useApi } from '@backstage/core-plugin-api';
import {
  CockpitActivityPage,
  createCockpitNavigationPort,
} from '@internal/spassu-code-cockpit-ui';
import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { frontierCockpitApiRef } from './FrontierCockpitApi';
import { adaptFrontierCockpit } from './frontierCockpitAdapter';

export const FrontierActivityCockpitPage = ({
  activityId,
}: {
  activityId: string;
}) => {
  const api = useApi(frontierCockpitApiRef);
  const [searchParams, setSearchParams] = useSearchParams();
  const navigation = useMemo(
    () =>
      createCockpitNavigationPort(searchParams, search =>
        setSearchParams(search, { replace: true }),
      ),
    [searchParams, setSearchParams],
  );
  return (
    <CockpitActivityPage
      activityId={activityId}
      dataSource={api}
      adaptSnapshot={adaptFrontierCockpit}
      navigation={navigation}
      loadingTitle="Carregando cockpit Frontier"
    />
  );
};
